import { IUserProfileRole, IUserRole } from '../pages/UsersPage/constants'

const INVESTIGATOR: IUserRole = {id: 1, value: 'INVESTIGATOR', label: 'Investigator'}
const ORG_ADMIN: IUserRole = {id: 2, value: 'ADMIN', label: 'Organization Administrator'}
const DESIGNATED_RECEIVER: IUserRole = {id: 3, value: 'DESIGNATED_RECEIVER', label: 'Designated Receiver'}

const roles: IUserRole[] = [ORG_ADMIN, DESIGNATED_RECEIVER, INVESTIGATOR]

//from server we get array of values like ['ADMIN', 'DESIGNATED_RECEIVER']
const getUserRolesFromUserProfile = (userProfileRoles : IUserProfileRole[]) => {
  // console.log(userProfileRoles)
  const userRoles: IUserRole[] = []

  userProfileRoles.forEach(role => {
    roles.forEach(r => {
      if(r.value === role.text) {
        userRoles.push(r)
      }
    })
  })

  return userRoles
}

const getUserRoleLabelsFromUserProfile = (userProfileRoles : IUserProfileRole[]) => {
  const userRoles: IUserRole[] = getUserRolesFromUserProfile(userProfileRoles)
  let label = ''

  userRoles.forEach(role => {
    label += role.label + ', '
  })

  if(label.length > 0 && label.endsWith(', ')) {
    label = label.substring(0, label.length - 2)
  }

  return label
}


export {
  getUserRolesFromUserProfile,
  getUserRoleLabelsFromUserProfile,
  ORG_ADMIN,
  INVESTIGATOR,
  DESIGNATED_RECEIVER
}

export type {IUserRole}

